<template>
	<div>
		<div class="topbar">

			<div>
				<el-input v-model="searchValue" size="mini" prefix-icon="el-icon-search" style="width: 400px"
					@keyup.enter.native="search()" />

				<el-button :disabled="!searchValue" type="primary" size="mini" icon="el-icon-search"
					style="margin-left: 10px" @click="search()">
					搜索
				</el-button>

			</div>

			<div>
				<el-button :disabled="pageOpt.totalCount <= 0" type="success" size="mini" icon="el-icon-download"
					style="margin-left: 10px" @click="export2Excel">
					导出excel
				</el-button>
			</div>
		</div>

		<el-table v-loading="loading" :data="tableData" border stripe class="data-table"
			:header-cell-style="{ background: '#F5F7FA' }">
			<el-table-column label="编号" prop="liveChatRecordsID" width="200" align="center" />

			<el-table-column label="发言时间" width="200" align="center">
				<template slot-scope="scope">
					{{ scope.row.createTime | formatDateTime }}
				</template>
			</el-table-column>

			<el-table-column label="用户名" width="200" align="center">
				<template slot-scope="scope">
					{{ scope.row.firstName + scope.row.lastName }}
				</template>
			</el-table-column>

			<el-table-column label="内容" prop="chatContent" align="center" />
		</el-table>

		<!-- 分页 -->
		<el-pagination background :total="pageOpt.totalCount" :page-size="pageOpt.pageSize"
			:current-page="pageOpt.currentPage" @current-change="curPageChange" />
	</div>
</template>

<script>
	import {
		getChatRecords,
	} from "@/api/mai/liveManagement/liveManagement";

	import {
		isVaild
	} from "@/utils/validate"

	import {
		export_json_to_excel
	} from "@/vendor/Export2Excel.js"
	export default {
		data() {
			return {
				liveID: 0,
				loading: false, // 加载开关
				tableData: [], // 传值给子组件mytable
				// 分页配置
				pageOpt: {
					currentPage: 1,
					pageSize: 10,
					totalCount: 0,
				},
				searchValue: "",
			}
		},

		created() {
			this.liveID = this.$route.query.liveID
		},
		props: {
			type: {
				type: Number,
				default: 0
			},
		},
		mounted() {
			this.getChatRecordList()
		},

		methods: {
			getChatRecordList() {
				this.loading = true;
				const liveID = this.liveID;
				const params = {
					keyWord: this.searchValue,
					type: this.type,
					liveID: liveID,
					pageIndex: this.pageOpt.currentPage,
					pageSize: this.pageOpt.pageSize,
					sortName: "",
					sortOrder: "",
				};

				getChatRecords(params).then((res) => {
					this.reserveUsersList = res.data.list;
					this.tableData = this.reserveUsersList;
					this.pageOpt.totalCount = res.data.total;

					this.utils.stopLoading(this);
				});
			},
			curPageChange(curPage) {
				this.pageOpt.currentPage = curPage
				this.getChatRecordList();
			},
			search() {
				this.pageOpt.currentPage = 1
				this.getChatRecordList()
			},
			getExcelInfo() {
				let tName;
				let tHeader;
				let filterValue;
				switch (this.type) {
					case 0:
						tName = '聊天记录'
						break;
					case 2:
						tName = '答疑列表'
						break;
					case 3:
						tName = '公告'
						break;
				}

				tHeader = ['编号', '发言时间', '用户', '聊天内容']
				filterValue = [
					'liveChatRecordsID',
					'createTime',
					'userName',
					'chatContent'
				]
				return {
					tName,
					tHeader,
					filterValue
				}

			},
			export2Excel() {
				let {
					tName,
					tHeader,
					filterValue
				} = this.getExcelInfo()
				this.getAllRecordInfo(this.type, tName, tHeader, filterValue)
			},
			getAllRecordInfo(type, tName, tHeader, filterValue) {
				this.loading = true;
				const liveID = this.liveID;
				const params = {
					keyWord: this.searchValue,
					type: this.type,
					liveID: liveID,
					pageIndex: 0,
					pageSize: this.pageOpt.totalCount,
					sortName: "",
					sortOrder: "",
				};

				getChatRecords(params).then((res) => {
					let list = this.formatChatInfoTable(res.data.list)
					let data = this.formatJson(filterValue, list)
					export_json_to_excel({
						header: tHeader,
						data,
						filename: tName,
						autoWidth: true,
						bookType: "xlsx",
					})
					this.utils.stopLoading(this)
				});
			},
			/**
			 * 格式化 JSON
			 *
			 * @param filterValue
			 * @param jsonData
			 */
			formatJson(filterValue, jsonData) {
				return jsonData.map(x => filterValue.map(y => {
					return x[y]
				}))
			},
			/**
			 * 格式化 userInfoTable
			 *
			 * @param list
			 */
			formatChatInfoTable(list) {
				let newList = list.map(item => {
					item.userName = item.firstName + item.lastName
					item.createTime = this.$options.filters["formatDateTime"](item.createTime)
					return item
				})

				return newList
			},

		},
	}
</script>

<style>
</style>
